<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-01-31 22:30 -->
<!-- Description:  -->
<template>
  <div>
    <h4>CONFIGURACION DE PROFESIONAL</h4>
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link" href="javascript:void(0)" 
          :class="{'active': tab == 'data'}" @click="setTab('data')">Datos</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="javascript:void(0)" 
          :class="{'active': tab == 'horary'}" @click="setTab('horary')">Horario</a>
      </li>
    </ul>
    <div v-if="tab == 'data'" class="row">
      <div class="col-md-12 col-lg-8">
        <EmployeeForm :key="employee.id" :content="employee"
           @saved="handlerAfterSave($event)"
        ></EmployeeForm>
      </div>
    </div>
    <div v-if="tab == 'horary'">
      <EmployeeHorary :employee_id="id" @saved="setTab('data')"></EmployeeHorary>
    </div>
  </div>
</template>
<script>
import {AdminService} from "src/lt/admin-module/AdminService.js";
import EmployeeForm from "./EmployeeForm.vue";
import EmployeeHorary from "./EmployeeHorary.vue";
import {param} from "jquery";

// script content
export default {
  name: "DoctorConfigView",
  components: {
    EmployeeForm,
    EmployeeHorary,
  },

  // directives

  props: {
    id: {}
  },

  data: () => ({
    employee: {},
    tab: 'data',
  }),

  computed: {
    //
  },

  // watch: {},

  created() {
    if(this.$route.query.tab) {
      this.tab = this.$route.query.tab;
    }
  },

  mounted() {
    this.reload();
  },

  methods: {
    handlerAfterSave(ev) {
      if(this.$route.name == 'dent.doctor-new') {
        this.$router.push({
          name: 'dent.doctor-config',
          params: { id: ev.id }
        });
      }
    },
    async reload() {
      let res = await AdminService.getEmployee(this.id);
      this.employee = res;
    },
    setTab(tabName) {
      this.tab = tabName;
      this.$router.push({ query: {tab: tabName} });
    }
  }
};
</script>
<style scoped></style>

